import defaultsDeep from 'lodash/defaultsDeep';

import TGeneralUserConfig from '../../../models/user-config/GeneralUserConfig';
import IUserConfigService from '../../../services/user-config/IUserConfigService';
import UserConfigService from '../../../services/user-config/UserConfigService';
import { getSessionApplication } from '../../selectors/session';
import { getCurrentThemeName } from '../../selectors/theme';
import themeActions from '../../slices/theme';
import userConfigActions from '../../slices/userConfig';
import { apiCall, createAppListener } from '../listenerHelpers';

const userConfigListener = createAppListener();

const userConfigService: IUserConfigService = new UserConfigService();

userConfigListener.startListening(
  apiCall(
    {
      request: userConfigActions.savePanelLinks,
      success: userConfigActions.savePanelLinksSuccess,
      failure: userConfigActions.savePanelLinksFailure,
    },
    async payload => {
      await userConfigService.savePanelLinks(payload);
      return payload;
    }
  )
);

userConfigListener.startListening(
  apiCall(
    {
      request: userConfigActions.getPanelLinks,
      success: userConfigActions.getPanelLinksSuccess,
      failure: userConfigActions.getPanelLinksFailure,
    },
    async () => {
      return userConfigService.getPanelLinks();
    }
  )
);

userConfigListener.startListening(
  apiCall(
    {
      request: userConfigActions.saveGeneral,
      success: userConfigActions.saveGeneralSuccess,
      failure: userConfigActions.saveGeneralFailure,
    },
    async ({ config, application }) => {
      const existData = await userConfigService.getGeneralConfig();
      const { pinnedTabs, ...rest } = config;

      const saveData: TGeneralUserConfig = defaultsDeep({}, rest, existData);

      if (application) {
        if (pinnedTabs) {
          saveData.pinnedTabs = {
            ...existData.pinnedTabs,
            [application]: pinnedTabs[application],
          };
        }
      }

      await userConfigService.saveGeneralConfig(saveData);
      return saveData;
    }
  )
);

userConfigListener.startListening(
  apiCall(
    {
      request: userConfigActions.getGeneral,
      success: userConfigActions.getGeneralSuccess,
      failure: userConfigActions.getGeneralFailure,
    },
    async (_payload, state, dispatch) => {
      const data = await userConfigService.getGeneralConfig();
      const { theme } = data;

      const app = getSessionApplication(state);
      const localTheme = getCurrentThemeName(state);

      const themeName =
        typeof theme === 'object' && app && theme[app]
          ? theme[app]
          : typeof theme === 'string'
            ? theme
            : undefined;

      if (themeName && themeName !== localTheme) {
        dispatch(themeActions.apply(themeName));
      }

      return data;
    }
  )
);

export default userConfigListener.middleware;
